import { Directive } from '@angular/core';

/** Marca il contenuto proiettato come suffix (es. icona cane/gatto) nella riga controllo. */
@Directive({
  selector: '[ariaFieldSuffix]',
  standalone: true,
})
export class AriaFieldSuffixDirective {}
